// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1PyBT","modal":"Modal_modal__1QaeJ","slide-down":"Modal_slide-down__2_u7E"};